//
// Shared attributes for cookies set client-side via js-cookie.
//
// `secure` is only applied over https (it would prevent the cookie from being
// set on http://localhost during local dev). `sameSite: 'lax'` matches the
// modern browser default and provides CSRF protection.
//
export const clientCookieOptions = {
  sameSite: 'lax',
  secure: typeof window !== 'undefined' && window.location.protocol === 'https:'
}
